export default "__VITE_ASSET__NIOaRYCY__";